import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45c7bb2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading px20" }, "カテゴリ一覧", -1))
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("完了")
const _hoisted_5 = {
  key: 1,
  class: "flex"
}
const _hoisted_6 = { class: "px20" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "カテゴリ一覧", -1))
const _hoisted_8 = {
  key: 0,
  class: "text-center"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("編集")
const _hoisted_10 = { class: "learning-header px20" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "トレーニングコース一覧", -1))
const _hoisted_12 = { class: "add-action text-right" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 39.46 39.46",
  width: "31px",
  height: "31px",
  class: "position"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "レイヤー_2",
    "data-name": "レイヤー 2"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "レイヤー_1-2",
      "data-name": "レイヤー 1"
    }, [
      /*#__PURE__*/_createElementVNode("circle", {
        class: "cls-1-disabled",
        cx: "19.73",
        cy: "19.73",
        r: "19.73"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        class: "cls-2",
        d: "M29.28,21.43h-7.8V29.2H18V21.43H10.17V18H18V10.26h3.5V18h7.8Z"
      })
    ])
  ])
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 39.46 39.46",
  width: "31px",
  height: "31px",
  class: "position"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "レイヤー_2",
    "data-name": "レイヤー 2"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "レイヤー_1-2",
      "data-name": "レイヤー 1"
    }, [
      /*#__PURE__*/_createElementVNode("circle", {
        class: "cls-1",
        cx: "19.73",
        cy: "19.73",
        r: "19.73"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        class: "cls-2",
        d: "M29.28,21.43h-7.8V29.2H18V21.43H10.17V18H18V10.26h3.5V18h7.8Z"
      })
    ])
  ])
], -1))
const _hoisted_15 = { class: "learning-list__card px20" }
const _hoisted_16 = ["infinite-scroll-disabled"]
const _hoisted_17 = { class: "flex-only" }
const _hoisted_18 = { class: "mr10" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "text-right mt5" }
const _hoisted_22 = { class: "mr10" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("START")
const _hoisted_24 = { class: "mr10" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("履歴確認")
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("履歴確認")
const _hoisted_29 = {
  key: 0,
  class: "mr10"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode("詳細")
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("編集")

import { ref, onMounted, computed, watch } from "vue";
import { library } from '@fortawesome/fontawesome-svg-core'
import { useStore } from "vuex";
import { useRoute } from 'vue-router'
import { ElMessage } from "element-plus"
import CategoryList from "@/components/common/categories/CategoryList.vue"
import LearningCategoriesEdit from "@/components/common/categories/CategoriesEdit.vue";
import { LearningCategoryLogic } from "@/logic/learning/LearningCategoryLogic";
import { LearningCourseListLogic } from "@/logic/learning/LearningCourseListLogic";
import { faCheckCircle, faCircle } from '@fortawesome/free-solid-svg-icons'
import { SelectCategoryState } from '@/state/SelectCategoryState'
import { Category } from '@/types/category'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

library.add(faCheckCircle, faCircle);

const store = useStore();
const route = useRoute()
const selectCategory = computed(() => SelectCategoryState.state.selectCategory);
const latestSelectCategory = computed(() => SelectCategoryState.state.latestSelectCategory);

const { loadLearningCategories,
  addLearningCategory,
  updateLearningCategory,
  deleteLearningCategory,
  sortLearningCategory,
  learningCategories,
  learningCategoryLoading
} = LearningCategoryLogic();
const { getLearningCourses, learningCourseListLoading, learningCourses, noMore } = LearningCourseListLogic()
const disabled = computed(() => learningCourseListLoading.value || noMore.value)
// const managerFlg = computed(() => store.state.login.manager_flg);
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);

let learningCategoryEditMode = ref(false)
let filterText = ref("")
let selectCategoryId = ref(0)
const projectId = computed(() => Number(route.params.project_id));
const switchCategryEditMode = (val: boolean) => {
  learningCategoryEditMode.value = val;
  selectCategoryAndloadLearning(0)
}
const load = () => {
  getLearningCourses(Number(route.params.project_id), selectCategoryId.value, false)
}
const categoryAndloadLearning = (category: Category) => {
  selectCategoryAndloadLearning(category.id)
  SelectCategoryState.latestCategoryIdSet(category.id)
}


const selectCategorySet = (category: Category) => {
  SelectCategoryState.set(category.id);
}
const selectCategoryDelete = (category: Category) => {
  SelectCategoryState.delete(category.id);
  for(const ids of closeNodeChildrenIds(category)){
    SelectCategoryState.delete(ids.id);
  }
}
const closeNodeChildrenIds = (parent) => {
  let close_node_id_list = [];
  close_node_id_list = close_node_id_list.concat(parent.children);
  parent.children.forEach((childrenId) => {
    close_node_id_list = close_node_id_list.concat(closeNodeChildrenIds(childrenId));
  });
  return close_node_id_list;
}
const selectCategoryAndloadLearning = (category_id: number) => {
  // リストを再描画しないと無限ループがうまく動かないので:keyでcategory_id指定してるので、同じカテゴリの場合は何もしないようにしておかないと無限ループがおかしくなる
  if (selectCategoryId.value == category_id) {
    return
  }
  selectCategoryId.value = category_id;
  getLearningCourses(Number(route.params.project_id), selectCategoryId.value, true)
}

const loadCategories = () => {
  loadLearningCategories();
};

watch(() => route.params.project_id, () => {
  if (route.params.project_id) {
    loadCategories();
  }
})
onMounted(async() => {
  await loadCategories();
  SelectCategoryState.selectedCategoryAndlatestCategorySet();
  if(latestSelectCategory.value > 0){
    selectCategoryId.value = latestSelectCategory.value;
  }
});
const openAlert = () => {
  ElMessage({
    showClose: true,
    message: '左のカテゴリ一覧からカテゴリを選択してください',
    type: 'error',
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_fa = _resolveComponent("fa")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_unref(learningCategoryEditMode))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createVNode(_component_el_card, { class: "category-list edit-category" }, {
          default: _withCtx(() => [
            _hoisted_2,
            (_unref(learningCategoryEditMode))
              ? (_openBlock(), _createBlock(LearningCategoriesEdit, {
                  key: 0,
                  class: "colum-flex-body",
                  onUpdateCategory: _unref(updateLearningCategory),
                  onAddCategory: _unref(addLearningCategory),
                  onDeleteCategory: _unref(deleteLearningCategory),
                  onSortCategory: _unref(sortLearningCategory),
                  categories: _unref(learningCategories)
                }, null, 8, ["onUpdateCategory", "onAddCategory", "onDeleteCategory", "onSortCategory", "categories"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                style: {"width":"80%"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (switchCategryEditMode(false)))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 512), [
          [_directive_loading, _unref(learningCategoryLoading)]
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _withDirectives(_createVNode(_component_el_card, { class: "category-list" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_el_input, {
                modelValue: _unref(filterText),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(filterText) ? (filterText).value = $event : filterText = $event)),
                placeholder: "キーワードを入力",
                class: "el-input-round el-input-height"
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(CategoryList, {
              class: "colum-flex-body mt10",
              filterText: _unref(filterText),
              categories: _unref(learningCategories),
              onListClick: categoryAndloadLearning,
              onOpenClick: selectCategorySet,
              onCloseClick: selectCategoryDelete,
              expandNodeKey: _unref(selectCategory),
              currentNodeKey: _unref(SelectCategoryState).getLatestCategoryId()
            }, null, 8, ["filterText", "categories", "expandNodeKey", "currentNodeKey"]),
            (_unref(managerFlg))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_el_button, {
                    style: {"width":"260px"},
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (switchCategryEditMode(true)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 512), [
          [_directive_loading, _unref(learningCategoryLoading)]
        ]),
        _createVNode(_component_el_card, { class: "main" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                (_unref(managerFlg) && _unref(selectCategoryId) == 0)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      plain: true,
                      onClick: openAlert,
                      class: "unstyled-button"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(managerFlg) && _unref(selectCategoryId) > 0)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      class: "unstyled-button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'ProjectLearningCourseNew', params: { project_id: _unref(projectId), category_id: _unref(selectCategoryId) } })))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives((_openBlock(), _createElementBlock("ul", {
                "infinite-scroll-disabled": _unref(disabled),
                key: _unref(selectCategoryId),
                class: "flex-column"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(learningCourses), (learning_course) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "learning-course",
                    key: learning_course.id
                  }, [
                    _createVNode(_component_el_card, {
                      class: "px10 mt5",
                      shadow: "never"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, [
                            (learning_course.answered == true)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                  _createVNode(_component_fa, {
                                    class: "color-success",
                                    icon: "check-circle"
                                  })
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                  _createVNode(_component_fa, {
                                    class: "color-gray",
                                    icon: "circle"
                                  })
                                ]))
                          ]),
                          _createElementVNode("span", null, _toDisplayString(learning_course.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("span", _hoisted_22, [
                            _createVNode(_component_router_link, {
                              to: { name: 'ProjectLearningCourse', params: { project_id: _unref(projectId), learning_course_id: learning_course.id } },
                              class: "button-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  size: "small",
                                  round: ""
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_23
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _createElementVNode("span", _hoisted_24, [
                            (learning_course.answered == true)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'ProjectLearningCourseHistory', params: { project_id: _unref(projectId), learning_course_id: learning_course.id } },
                                    class: "button-link"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        size: "small",
                                        round: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_26
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                  _createVNode(_component_el_button, {
                                    size: "small",
                                    round: "",
                                    disabled: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_28
                                    ]),
                                    _: 1
                                  })
                                ]))
                          ]),
                          (_unref(managerFlg))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                _createVNode(_component_router_link, {
                                  to: { name: 'ProjectLearningCourseShow', params: { project_id: _unref(projectId), learning_course_id: learning_course.id } },
                                  class: "button-link"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      size: "small",
                                      round: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_30
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(managerFlg))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                                _createVNode(_component_router_link, {
                                  to: { name: 'ProjectLearningCourseEdit', params: { project_id: _unref(projectId), learning_course_id: learning_course.id } },
                                  class: "button-link"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      type: "info",
                                      size: "small",
                                      round: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_32
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ], 8, _hoisted_16)), [
                [_directive_infinite_scroll, load]
              ])
            ]),
            _withDirectives(_createElementVNode("div", null, null, 512), [
              [_directive_loading, _unref(learningCourseListLoading)]
            ])
          ]),
          _: 1
        })
      ]))
}
}

})